import { BaseFiltroPagDTO } from "./base-dto";

export class PrescricaoHistDTO {
    id: Number;
    idSeqSipro: string;
    data: string;
    pesoPaciente: Number;
    nomeMedico: string;
    volume: Number;
    viaAdministracao: string;
    tempoInfusao: string;
    osmolaridade: number;

    produtos: PrescricaoProdutoHistDTO[];
}

export class PrescricaoProdutoHistDTO {
    id: Number;
    codigo: string;
    nome: string;
    quantidadeMl: Number;
}

export class ProdutoUtilizadoParmDTO extends BaseFiltroPagDTO {
    idsClientes: number;
    idsUnidades: number[];
    idsMedicos: number[];
    idsPacientes: number[];
    idsProdutos: number[];
    dataDe: Date;
    dataAte: Date;
    agruparPor: string[];
}

export class ProdutoUtilizadoDTO {
    cliente: string;
    unidade: string;
    medico: string;
    crmMedico: string;
    paciente: string;
    produto: string;
    codProduto: string;
    qtdeTotalMl: number;
}